import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { TimeSaleProductTemplate } from 'components/Templates'

const TimeSaleProduct: FC = () => {
  return (
    <Layout iconPath={'/icon/white/clock.svg'} headline={'タイムセール'} title={'セール対象商品を選択'}>
      <TimeSaleProductTemplate />
    </Layout>
  )
}

export default TimeSaleProduct
